import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Country { id: number; name: string; code: string | null; }
export interface ServiceItem { service_id: number; service_name: string; }

export interface QuotePayload {
  full_name: string;
  business_email: string;
  phone_number: string;
  company_name: string;
  country: string;
  type_of_service: string;
}
@Injectable({
  providedIn: 'root',
})
export class ServicesQuoteService {
 private base = environment.baseUrl;

  constructor(private http: HttpClient) {}

  getServices(): Observable<{ success: boolean; data: ServiceItem[] }> {
    return this.http.get<{ success: boolean; data: ServiceItem[] }>(`${this.base}/services/`);
  }

  getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(`${this.base}/locations/countries`);
  }



  submitQuote(
    payload: QuotePayload,
    utmParams?: {
      utm_source?: string;
      utm_medium?: string;
      utm_campaign?: string;
      utm_content?: string;
    }
  ): Observable<any> {
    let params = new HttpParams();

    if (utmParams) {
      Object.entries(utmParams).forEach(([key, value]) => {
        if (value) {
          params = params.set(key, value);
        }
      });
    }

    return this.http.post(
      `${this.base}/Maltech/DiscussProject/`,
      payload,
      { params }
    );
  }


}
